import React, { useEffect, useState } from "react";
import "./FarmerDashboard.css";
import axios from "axios";
import { Button, Input, Select, Table } from "antd";
import PortraitIcon from "@mui/icons-material/Portrait";
import { Link } from "react-router-dom/";
import Tooltip from "@mui/material/Tooltip";
import config from "../../config";
import authHeader from "../Authentication/authHeader";
import QRCodeGenerator from "./FarmersTemplate/QRCodeGenerator";
import { faR } from "@fortawesome/free-solid-svg-icons";

export default function FarmerDashboard() {
  const { Search } = Input;
  const { Option } = Select;
  const [farmerList, setFarmerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [farmerCountData, setFarmerCountData] = useState({});
  const [farmerFilterData, setFarmerFilterData] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/api/farmerCount/${farmerFilterData}/`, {
        headers: authHeader(),
      })
      .then((results) => {
        setFarmerCountData(results?.data);
      });
  }, [farmerFilterData]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${config.baseUrl}/api/farmerList/`, {
        headers: authHeader(),
        params: {
          page: currentPage,
          filter: filter,
        },
      })
      .then((results) => {
        setFarmerList(results?.data.results || []);
        setTotalItems(results?.data.count || 0);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [currentPage, filter]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const columns = [
    {
      title: "Farmer ID",
      dataIndex: "farmer_id",
      width: "18%",
    },
    {
      title: "Farmer Name",
      dataIndex: "name",
      width: "13%",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      width: "12%",
      render: (text) => {
        return "0" + text; // Add '0' to the beginning of the phone number
      },
    },
    {
      title: "District",
      render: (record) => record?.district?.district_name,
      width: "12%",
    },
    {
      title: "Upazila",
      render: (record) => record?.upazila?.upazila_name,
      width: "12%",
    },
    {
      title: "Union",
      render: (record) => record?.union?.union_name,
      width: "12%",
    },
    {
      title: "Village",
      render: (record) => record?.village,
      filterSearch: true,
      width: "14%",
    },
    {
      title: "Action",
      key: "actions",
      width: "15%",
      render: (record) => (
        <div className="d-flex justify-content-center align-items-center">
          <Link
            className="actionBtnDesign me-4 shadow"
            to={`/farmerProfile/${record?.farmer_id}`}
            target="_blank"
          >
            <Tooltip title="Profile">
              <PortraitIcon />
            </Tooltip>
          </Link>
          <QRCodeGenerator name={record?.name} id={record?.farmer_id} type="farmerProfile"/>
        </div>
      ),
    },
  ];
  const farmerDistrictValue = (value) => {
    setFarmerFilterData(value);
  };
  const handleFilterChange = (value) => {
    setFilter(value);
  };

  return (
    <div className="farmerDashboard">
      <div className="dashboardNameSection">
        <h5 style={{ color: "#46604A" }}>FARMER'S DASHBOARD</h5>
      </div>
      <div className="farmerDashboardContainer shadow-sm rounded">
        <div className="farmerBoxSection">
          <div className="farmerCardDesign">
            <p className="m-3" style={{ fontSize: "18px" }}>
              Total Registered Farmer
            </p>
            <p className="m-3" style={{ fontSize: "30px" }}>
              {farmerCountData?.total_count || 0}
            </p>
          </div>
          <div className="farmerCardDesign">
            <p className="m-3" style={{ fontSize: "18px" }}>
              Livestock Farmer
            </p>
            <p className="m-3" style={{ fontSize: "30px" }}>
              {farmerCountData?.livestock_count || 0}
            </p>
          </div>
          <div className="farmerCardDesign">
            <p className="m-3" style={{ fontSize: "18px" }}>
              Crop Farmer
            </p>
            <p className="m-3" style={{ fontSize: "30px" }}>
              {farmerCountData?.crop_count || 0}
            </p>
          </div>
          <div className="farmerCardDesign">
            <p className="m-3" style={{ fontSize: "18px" }}>
              Both Farmer
            </p>
            <p className="m-3" style={{ fontSize: "30px" }}>
              {farmerCountData?.crop_livestock_count || 0}
            </p>
          </div>
          <div className="farmerCardDesign">
            <p className="mt-3 ms-3">District Filter:</p>
            <Select
              className="ms-3 w-50"
              name="Select"
              onChange={farmerDistrictValue}
              placeholder="Select District"
              showSearch
            >
              <Option value="all">District</Option>
              {farmerCountData?.district_values?.map((item, index) => (
                <Option key={index} value={item}>
                  {item}
                </Option>
              ))}
            </Select>
          </div>
        </div>

        <div className="m-2 mt-4 d-flex justify-content-end align-items-center">
          <Search
            className="w-25"
            placeholder="search here..."
            allowClear
            onSearch={handleFilterChange}
            enterButton={
              <Button
                style={{
                  backgroundColor: "#46604A",
                  borderColor: "#46604A",
                  color: "white",
                }}
              >
                Search
              </Button>
            }
          />
        </div>

        <div className="m-2 border">
          <Table
            columns={columns}
            dataSource={farmerList}
            loading={loading}
            rowKey={(record) => record.farmer_id}
            pagination={{
              current: currentPage,
              total: totalItems,
              pageSize: 10, // Set the number of items per page
              onChange: handlePageChange,
            }}
          />
        </div>
      </div>
    </div>
  );
}
